import React, { Component } from 'react';
import FilterStep from './FilterStep';

class Filters extends Component {
	constructor(props) {
		super(props);

		this.handleStepChange = this.handleStepChange.bind(this);
	}
	handleStepChange(id, stepNumber) {
		this.props.onFilterChange(id, stepNumber);
	}
	render() {
		var items = this.props.items;

		return (
			<div className="filters elementary">

				{items.map((step, index) =>
					<FilterStep key={index} step={step} chosenIds={this.props.chosenIds} onStepChange={this.handleStepChange} />
				)}
				
			</div>
		);
	}
}

export default Filters;
